'use client';

import clsx from 'clsx';
import { useState } from 'react';
import InquiryButton from './InquiryButton';

export default function TopBanner() {
  const [toggleHide, setTggleHide] = useState(false);
  const onClickClose = () => {
    setTggleHide(!toggleHide);
  };

  return (
    <div className={clsx('top_banner', toggleHide === true && 'hide')}>
      <div className="inner">
        <InquiryButton position="top-banner" />
        <button className="btn_close" type="button" onClick={onClickClose}>
          <i className="icon_close" />
        </button>
      </div>
    </div>
  );
}
